import React from "react";
import { Typography, Box, Stack, Divider, Paper, CircularProgress } from "@mui/material";
import { CheckCircle, Cancel } from "@mui/icons-material";

const AbsentPresentChart = ({ counts = { present_count: 0, absent_count: 0 } }) => {
    
    const presentCount = counts.present_count || 0;
    const absentCount = counts.absent_count || 0;
    const total = presentCount + absentCount;

    const attendanceRate = total > 0 ? Math.round((presentCount / total) * 100) : 0;
    const absentRate = total > 0 ? Math.round((absentCount / total) * 100) : 0;

    const getAttendanceColor = (rate) => {
        if (rate >= 90) return '#4caf50';
        if (rate >= 75) return '#ff9800';
        return '#f44336';
    };

    return (
        <Box sx={{ p: 2, height: '100%' }}>
            <Box sx={{ mb: 2 }}>
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <Typography variant="h6" fontWeight="bold">
                        Attendance status
                    </Typography>
                </Stack>
                <Typography variant="body2" color="text.secondary">
                    Absent, present ratio
                </Typography>
                <Divider sx={{ mt: 1 }} />
            </Box>

            {/* Radial Gauge */}
            <Box sx={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress 
                        variant="determinate" 
                        value={attendanceRate} 
                        size={150}
                        thickness={4}
                        sx={{ 
                            color: getAttendanceColor(attendanceRate),
                            position: 'relative',
                        }}
                    />
                    
                    {/* Center Stats */}
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        textAlign: 'center'
                    }}>
                        <Typography variant="h3" fontWeight="bold" color={getAttendanceColor(attendanceRate)}>
                            {attendanceRate}%
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Attendance Rate
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* Breakdown Cards */}
            <Stack spacing={1} mt={1}>
                <Paper sx={{ p: 1.5 }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <CheckCircle sx={{ color: '#2e7d32' }} />
                            <Box>
                                <Typography variant="subtitle2">Present</Typography>
                                <Typography variant="caption" color="text.secondary">
                                    Students attended
                                </Typography>
                            </Box>
                        </Stack>
                        <Box textAlign="right">
                            <Typography variant="h6" fontWeight="bold" color="#2e7d32">
                                {presentCount}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {attendanceRate}%
                            </Typography>
                        </Box>
                    </Stack>
                </Paper>

                <Paper sx={{ p: 1.5 }}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <Cancel sx={{ color: '#d32f2f' }} />
                            <Box>
                                <Typography variant="subtitle2">Absent</Typography>
                                <Typography variant="caption" color="text.secondary">
                                    Students absent
                                </Typography>
                            </Box>
                        </Stack>
                        <Box textAlign="right">
                            <Typography variant="h6" fontWeight="bold" color="#d32f2f">
                                {absentCount}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {absentRate}%
                            </Typography>
                        </Box>
                    </Stack>
                </Paper>
            </Stack>
        </Box>
    );
}

export default AbsentPresentChart;